import PostModel from "./postModel";
export default function searchModel(pulseConfig, raw) {
    var _a, _b;
    const postMapper = new PostModel(pulseConfig);
    return (_b = (_a = raw === null || raw === void 0 ? void 0 : raw.posts) === null || _a === void 0 ? void 0 : _a.map((p) => postMapper.mapPost(p))) !== null && _b !== void 0 ? _b : [];
}
